var dhtmlx = {
    // 继承
    extend: function (e, c) {
        for (var g in c) {
            if (!e[g]) {
                e[g] = c[g];
            }
        }
        return e;
    },
    // 继承api
    extend_api: function (a, g, e) {
        var c = window[a];
        if (!c) {
            return;
        }
        window[a] = function (m) {
            var l = null;
            if (m && typeof m == "object" && !m.tagName) {
                l = c.apply(this, g._init ? g._init(m) : arguments);
                for (var h in dhtmlx) {
                    if (g[h]) {
                        this[g[h]](dhtmlx[h]);
                    }
                }
                for (var h_1 in m) {
                    if (g[h_1]) {
                        this[g[h_1]](m[h_1]);
                    }
                    else {
                        if (h_1.indexOf("on") === 0) {
                            this.attachEvent(h_1, m[h_1]);
                        }
                    }
                }
            }
            else {
                l = c.apply(this, arguments);
            }
            if (g._patch) {
                g._patch(this);
            }
            return l || this;
        };
        window[a].prototype = c.prototype;
        if (e) {
            dhtmlx.extend(window[a].prototype, e);
        }
    },
    //判断url中是否已经存在参数
    url: function (a) {
        if (a.indexOf("?") != -1) {
            return "&";
        }
        else {
            return "?";
        }
    }
};

export default dhtmlx;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/global/dhtmlx.js